<div class="card">
  <div class="card-body">
    <h4 class="card-title">Parti</h4>
    <div class="p-3" *ngIf="!isModifyDisabled" >
      <div class="row">
        <div  class="col-lg-4">
          <ng-multiselect-dropdown [settings]="partdropdownSettings" [placeholder]="'Prodotto'" name="categorie" [data]="prodotti"
            [(ngModel)]="prodottiSelezionati" (onFilterChange)="filtroProdtto($event)">
          </ng-multiselect-dropdown>
        </div>
        <div class="input-group col-lg-2 ">
          <input type="number" [(ngModel)]="qtaParti" class="form-control">
        </div>
        <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1">
          <button class="btn btn-outline-info rounded-pill" style="width: 100%;" (click)="add()" type="button">Aggiungi</button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
        <thead>
          <tr>
            <th>Parte</th>
            <th>Quantità</th>
            <th scope="col" *ngIf="!isModifyDisabled" >Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Parti">
             <td>
              <span>
                <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                  <i-feather name="info" class="feather-sm"></i-feather>
                </span>
                {{ item.nome }}
              </span>
            </td>
            <td>
              <span>
                <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                  <i-feather name="info" class="feather-sm"></i-feather>
                </span>
                {{ item.qta }}
              </span>
            </td>
            <td class="align-middle" *ngIf="!isModifyDisabled" >
              <a href="javascript:void(0)" ngbTooltip="Elimina"
                class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
                <i-feather name="trash-2" class="feather-sm"></i-feather>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-body">
    <h4 class="card-title">Variazioni</h4>
    <div class="p-3" *ngIf="!isModifyDisabled" >
      <div class="row">
        <div class="col-lg-3">
          <ng-multiselect-dropdown [settings]="partdropdownSettings" [placeholder]="'Prodotto'" name="prodotto" [data]="prodotti"
            [(ngModel)]="prodottiVariazioniSelezionati" (onFilterChange)="filtroProdtto($event)">
          </ng-multiselect-dropdown>
        </div>
        <div class="col-lg-3">
          <ng-multiselect-dropdown style="width: 80%; " [placeholder]="'Categoria'" name="variazione" [data]="CategorieLineare"
            [(ngModel)]="CategorieSelezionate" [settings]="categoriedropdownSettings"
            (onFilterChange)="filtroCategoria($event)">
          </ng-multiselect-dropdown>
        </div>
        <div class="input-group col-lg-2 ">
          <input type="number" [(ngModel)]="qtavar" class="form-control">
        </div>
        <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1">
          <button class="btn btn-outline-info rounded-pill" style="width: 100%;" (click)="addvar()" type="button">Aggiungi</button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
        <thead>
          <tr>
            <th>Parte</th>
            <th>Quantità</th>
            <th>Categoria</th>
            <th scope="col" *ngIf="!isModifyDisabled" >Azioni</th>
          </tr>
        </thead>
        <tbody *ngFor="let item of Variazioni">
          <tr *ngFor="let parte of item.parti">
             <td>
              <span>
                <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                  <i-feather name="info" class="feather-sm"></i-feather>
                </span>
                {{ parte.nome }}
              </span>
            </td>
            <td>
              <span>
                <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                  <i-feather name="info" class="feather-sm"></i-feather>
                </span>
                {{ parte.qta }}
              </span>
            </td>
            <td>
              <span>
                <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                  <i-feather name="info" class="feather-sm"></i-feather>
                </span>
                {{ item.categoria }}
              </span>
            </td>
            <td class="align-middle" *ngIf="!isModifyDisabled" >
              <a href="javascript:void(0)" ngbTooltip="Elimina"
                class="link font-16 text-danger font-weight-bold" (click)='deletevar(item, parte)'>
                <i-feather name="trash-2" class="feather-sm"></i-feather>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
